import { PdfViewer } from 'shared/ui/pdf-viewer';
import { CloseIcon } from 'shared/ui/icons';

const PdfViewerPanel = ({ pdfOpen, onClose, fileUrl }) => (
  <div className={`h-full border-2 ${pdfOpen ? 'block' : 'hidden'}`}>
    <div className="w-full flex items-center gap-4 border-b border-slate-200 py-7 px-4">
      <span
        className="text-sm font-normal text-blue-500 cursor-pointer"
        onClick={onClose}
      >
        <CloseIcon width="16" height="16" />
      </span>
      <span className="text-lg font-medium">SP KUASA.pdf</span>
    </div>
    <div className="w-full px-4 py-4">
      {fileUrl ? (
        <PdfViewer fileUrl={fileUrl} width="100%" />
      ) : (
        <div className="text-center text-gray-500 py-10">
          File PDF tidak tersedia
        </div>
      )}
    </div>
  </div>
);

export default PdfViewerPanel;
